import * as React from 'react';

import { translate } from '~l10n/client';

import { FocusIndicator } from '~shared/components/FocusIndicator/FocusIndicator';
import { TextSelectInput } from '~shared/components/TextSelectInput';
import { Direction } from '~shared/utils/sort';
import { ScoreDisplay } from '~teacher/components/ResultsGrid/types';

import { ResultsSortIndicator } from './ResultsSortIndicator';

export const scoreDisplayOptions = [
  { text: `${translate('Progress')}`, value: ScoreDisplay.ProgressPercent },
  { text: `${translate('Score')} %`, value: ScoreDisplay.ScorePercent },
  { text: `${translate('Score')} #`, value: ScoreDisplay.ScoreNumber },
];

interface CellProps {
  onNamePress: React.ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  sortDirection: Direction;
  scoreDisplay: ScoreDisplay;
  setScoreDisplay: (scoreDisplay: ScoreDisplay) => void;
}

export function ResultsParticipantHeader({
  onNamePress,
  sortDirection,
  scoreDisplay,
  setScoreDisplay,
}: CellProps): React.ReactElement {
  return (
    <div className="relative flex items-center h-full">
      <div
        className="absolute top-0 w-1 border-r border-white border-solid h-full"
        style={{ left: '100%' }}
      />
      <div className="flex w-60">
        <button
          className="group relative px-4 py-3 bg-transparent border-0 rounded-2 outline-none cursor-pointer"
          onClick={onNamePress}
        >
          <div className="flex items-center">
            <span className="text-xs font-700 leading-6 text-cyan-700 tracking-wider uppercase">
              {translate('Name')}
            </span>
            <div className="flex pl-1">
              <ResultsSortIndicator direction={sortDirection} />
            </div>
          </div>
          <FocusIndicator notOffset isInset />
        </button>
      </div>
      <div className="flex justify-end w-40">
        <span className="text-xs font-700 leading-6 text-cyan-700 tracking-wider text-right uppercase whitespace-no-wrap">
          <TextSelectInput
            className="px-4 py-3"
            id="score-select"
            label={translate('Score Display')}
            options={scoreDisplayOptions}
            onChange={setScoreDisplay}
            value={scoreDisplay}
          />
        </span>
      </div>
    </div>
  );
}
